import { Link, WhatsApp } from "@mui/icons-material";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
// Material Kit 2 React components
import MKTypography from "components/MKTypography";
import YouTubeIcon from "@mui/icons-material/YouTube";
import IgIcon from "@mui/icons-material/Instagram";

// Images
import logoCT from "assets/images/logos/st/st_ind_color.png";
import TikTokIcon from "components/Icons/TikTok";
import XIcon from "components/Icons/XTweet";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "SHOWTHINK INDONESIA",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/share/18goYxHtux/?mibextid=wwXIfr",
    },
    {
      icon: <TikTokIcon style={{ color: "inherit", fontSize: "32px" }} />,
      link: "https://www.tiktok.com/@showthinkindonsia?_t=ZS-8vIZ9simYwq&_r=1",
    },
    {
      icon: <XIcon style={{ color: "inherit", fontSize: "32px" }} />,
      link: "https://x.com/onepeckerstudio?s=21",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/@showthinkindonesia/featured",
    },
    {
      icon: <IgIcon />,
      link: "https://www.instagram.com/showthink.indonesia/",
    },
    {
      icon: <WhatsApp />,
      link: "https://api.whatsapp.com/send/?phone=6285743355062&text&type=phone_number&app_absent=0",
    },
    {
      icon: <Link />,
      link: "https://linktr.ee/showthink.indonesia?utm_source=linktree_profile_share&ltsid=298a0bbb-eb3a-4bd5-8888-675f3b27a9cd",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "about us", href: "#" },
        { name: "blog", href: "#" },
      ],
    },
    {
      name: "help & support",
      items: [{ name: "contact us", href: "#" }],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}{" "}
      <MKTypography
        //component="a"
        //href="#"
        // target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        SHOWTHINK INDONESIA TEAM
      </MKTypography>
      .
    </MKTypography>
  ),
};
